import { useAllSession } from "./useAllSession";

import useUpdateSessionList from "./useUpdateSessionList";
import { SessionListItem } from "../types";
import { useSetAtom } from "jotai";
import { UnReadSessionsAtom } from "../store";

export default function useUpdateSession() {
    const updateSessionList = useUpdateSessionList();
    const { sessions } = useAllSession();
    const updateNewMessageMark = useSetAtom(UnReadSessionsAtom);

    // 删除会话
    function removeSession(sessionId: string | string[]) {
        const sessionIds =
            typeof sessionId === "string" ? [sessionId] : sessionId;

        sessionIds.forEach(sessionId => {
            const index = sessions.findIndex(item => item.guid === sessionId);
            sessions.splice(index, 1);
        });

        updateSessionList();
    }

    // 添加会话
    function addSession(session?: SessionListItem) {
        if (!session) return;
        // 新建的sessionId存在于已知列表中, 不做任何处理直接返回
        if (checkSessionExist(session.guid)) return;
        sessions.push(session);
        updateSessionList();
    }

    // 修改会话
    function updateSession(sessionId: string, data: Partial<SessionListItem>) {
        const index = sessions.findIndex(item => item.guid === sessionId);
        Object.assign(sessions[index], data);
        updateSessionList();
    }

    // 把会话标记为未读
    function markSessionUnRead(sessionId: string) {
        updateNewMessageMark((sessionIds: string[]) =>
            Array.from(new Set([...sessionIds, sessionId]))
        );
    }

    // 把会话标记为已读
    function markSessionRead(sessionId: string) {
        updateSession(sessionId, {
            notReadNoTypeList: undefined
        });

        updateNewMessageMark((sessionIds: string[]) =>
            sessionIds.filter(id => id !== sessionId)
        );
    }

    // 查找session是不是已经存在于列表
    function checkSessionExist(sessionId: string) {
        return !!sessions.find(item => item.guid === sessionId);
    }

    return {
        addSession,
        removeSession,
        updateSession,
        checkSessionExist,
        markSessionRead,
        markSessionUnRead
    };
}
